import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Button,
} from "@repo/ui";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function HoverDropdown({
  triggerComponent = <Button>Hover</Button>,
  list = [],
  itemProps = {},
}) {
  const [open, setOpen] = useState(false);

  return (
    <div
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      style={{ cursor: "pointer" }}
    >
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger asChild>
          <div className="flex flex-row justify-between p-2 cursor-pointer">
            {triggerComponent}
            <ChevronRight style={{ width: "12px" }} />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          side="right"
          sideOffset={4}
          align="start"
          alignOffset={0}
        >
          {list.map((elm) => (
            <DropdownMenuItem key={elm.text} {...itemProps}>
              {elm.to ? (
                <Link
                  to={elm.to}
                  style={{ width: "100%", display: "flex", textWrap: "wrap" }}
                >
                  {elm.text}
                </Link>
              ) : (
                <div {...itemProps} className="w-full">
                  {elm.text}
                </div>
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
